import * as Yup from "yup";
const SubtitlesLanguageValid = [
  "ab",
  "aa",
  "af",
  "ak",
  "sq",
  "am",
  "ar",
  "an",
  "hy",
  "as",
  "av",
  "ae",
  "ay",
  "az",
  "bm",
  "ba",
  "eu",
  "be",
  "bn",
  "bh",
  "bi",
  "bs",
  "br",
  "bg",
  "my",
  "ca",
  "km",
  "ch",
  "ce",
  "ny",
  "zh",
  "cu",
  "cv",
  "kw",
  "co",
  "cr",
  "hr",
  "cs",
  "da",
  "dv",
  "nl",
  "dz",
  "en",
  "eo",
  "et",
  "ee",
  "fo",
  "fj",
  "fi",
  "fr",
  "ff",
  "gd",
  "gl",
  "lg",
  "ka",
  "de",
  "ki",
  "el",
  "kl",
  "gn",
  "gu",
  "ht",
  "ha",
  "he",
  "hz",
  "hi",
  "ho",
  "hu",
  "is",
  "io",
  "ig",
  "id",
  "ia",
  "ie",
  "iu",
  "ik",
  "ga",
  "it",
  "ja",
  "jv",
  "kn",
  "kr",
  "ks",
  "kk",
  "rw",
  "kv",
  "kg",
  "ko",
  "kj",
  "ku",
  "ky",
  "lo",
  "la",
  "lv",
  "lb",
  "li",
  "ln",
  "lt",
  "lu",
  "mk",
  "mg",
  "ms",
  "ml",
  "mt",
  "gv",
  "mi",
  "mr",
  "mh",
  "ro",
  "mn",
  "na",
  "nv",
  "nd",
  "ng",
  "ne",
  "se",
  "no",
  "nb",
  "nn",
  "ii",
  "oc",
  "oj",
  "or",
  "om",
  "os",
  "pi",
  "pa",
  "ps",
  "fa",
  "pl",
  "pt",
  "qu",
  "rm",
  "rn",
  "ru",
  "sm",
  "sg",
  "sa",
  "sc",
  "sr",
  "sn",
  "sd",
  "si",
  "sk",
  "sl",
  "so",
  "st",
  "nr",
  "es",
  "su",
  "sw",
  "ss",
  "sv",
  "tl",
  "ty",
  "tg",
  "ta",
  "tt",
  "te",
  "th",
  "bo",
  "ti",
  "to",
  "ts",
  "tn",
  "tr",
  "tk",
  "tw",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "cy",
  "fy",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zu",
];

const selectVideoSchema = Yup.object().shape({
  videoType: Yup.string()
    .oneOf(["movie", "clip", "Serial"])
    .required("لطفا نوع ویدئو را انتخاب کنید"),
  // filmName: Yup.string().required("نام فیلم را وارد کنید"),
  season: Yup.number()
    .when(["videoType"], {
      is: "Serial",
      then: Yup.number().required("شماره فصل را وارد کنید"),
    })
    .min(1, "عدد باید بیشتر از 1 باشد"),
  episode: Yup.number()
    .when(["videoType"], {
      is: "Serial",
      then: Yup.number().required("شماره قسمت را وارد کنید"),
    })
    .min(1, "عدد باید بیشتر از 1 باشد"),
  // videoFile: Yup.string().required("فایل فیلم را از درون سیستم یا گوشی خود انتخاب کنید"),
});

const selectSubtitleOneSchema = Yup.object().shape({
  subtitleOneLanguage: Yup.string()
    .oneOf(SubtitlesLanguageValid, "لطفا فقط از لیست یک زبان را انتخاب کنید")
    .required("لطفا زبان زیرنویس را انتخاب کنید"),
  subtitleOneFile: Yup.string().required("زیرنویس اول را انتخاب کنید"),
  subtitleTwoOff: Yup.boolean(),
  subtitleTwoLanguage: Yup.string()
    .oneOf(SubtitlesLanguageValid, "لطفا فقط از لیست یک زبان را انتخاب کنید")
    .required("لطفا زبان زیرنویس را انتخاب کنید"),
  subtitleTwoFile: Yup.string().when(["subtitleTwoOff"], {
    is: false,
    then: Yup.string().required("زیرنویس دوم را انتخاب کنید"),
  }),
  //   .oneOf(["movie", "clip", "Serial"])
  //   .required("لطفا نوع ویدئو را انتخاب کنید"),
  // filmName: Yup.string().required("نام فیلم را وارد کنید"),
  // season: Yup.number().when(["videoType"], {
  //   is: "Serial",
  //   then: Yup.number().required("شماره فصل را وارد کنید"),
  // }).min(1,"عدد باید بیشتر از 1 باشد"),
  // episode: Yup.number().when(["videoType"], {
  //   is: "Serial",
  //   then: Yup.number().required("شماره قسمت را وارد کنید"),
  // }).min(1,"عدد باید بیشتر از 1 باشد"),
  // videoFile: Yup.string().required("یک فیلم انتخاب کنید"),
});

export { selectVideoSchema, selectSubtitleOneSchema };
